import styles from "./standings.module.scss"
import { AppContext } from "../../../../utils/context"
import { useContext } from "react"
import { CosmosText } from "@cosmos/web/react"

// Images
import rbrLogo from "../../../../assets/images/icons/redbullracing-logo.svg"
import Background from "../../../../components/background/backgroud"
import Car from "../../../../assets/images/icons/rb21_small.svg"
import Drivers from "../../../../assets/images/graphics/drivers.png"

// Returns the HTML markup for the standings slide
export default function Standings() {
    // Pull the standings from the context
    const { standings, constructorStandings } = useContext(AppContext)

    return (
        <>
        <Background bg={2} />
        <div className={styles.container}>
            <div className={styles.constructors}>
                <div className={styles.table}>
                    <div className={[styles.header, styles.constructor].join(" ")}>
                        <h1>CONSTRUCTORS CHAMPIONSHIP</h1>
                    </div>
                    <div className={styles.contents}>
                        {constructorStandings?.map((team, index) => (
                            <div
                                key={index}
                                className={[
                                    styles.row,
                                    team?.season_team_name === "Oracle Red Bull Racing"
                                        ? styles.highlight
                                        : "",
                                ].join(" ")}
                            >
                                <p className={styles.position}>
                                    {index + 1}
                                </p>
                                <div className={styles.border}>
                                    <p className={styles.name}>
                                        {team.season_team_name === "Oracle Red Bull Racing" ? <img className={styles.rbrLogo} src={rbrLogo}/> : team.season_team_name} 
                                    </p>
                                    <p className={[styles.name, styles.points].join(" ")} >{team.season_points}</p>
                                </div>
                            </div>
                        ))}
                    
                        <img src={Car} className={styles.car} />
                    </div>
                </div> 
            </div>
            <div className={styles.drivers}>
                <div className={styles.table}>
                    <div className={styles.header}>
                        <h1>DRIVER'S CHAMPIONSHIP</h1>
                    </div>
                    <div className={styles.contents}>
                        {standings?.map((driver, index) => (
                            <div
                                key={index}
                                className={[
                                    styles.row,
                                    driver?.season_team_name === "Oracle Red Bull Racing"
                                        ? styles.highlight
                                        : "",
                                    styles.driverTable
                                ].join(" ")}
                            >
                                <p className={styles.position}>
                                    {index + 1}
                                </p>
                                <div className={styles.border}>
                                    <p className={styles.name}>
                                        {driver.first_name} {driver?.season_team_name === "Oracle Red Bull Racing" ? "" : driver.last_name}
                                    </p>
                                    <p className={[styles.name, styles.points].join(" ")}>{driver.season_points}</p>
                                </div>
                            </div>
                        ))} 
                    </div>
                </div> 
                <img src={Drivers} className={styles.driversImage} />
            </div>
        </div>
        </>
    )
}